import React from "react";
import Logo from "../../../assets/images/logo.png";
import { useSelector } from "react-redux";
import "../CustomerPaymentPrint.css";
import moment from "moment";
import { Button } from "antd";
import numeral from "numeral";

const CustomerPaymentPrintHeader = () => {
  const { customerPaymentPrint } = useSelector((state) => state);
  const headerData = customerPaymentPrint && customerPaymentPrint?.payload?.data[0];

  const printHandler = () => {
    window.print();
  }

  return (
    <div className='new-sales-report'>
      <div className="new-sales-report-header" style={{width: '105%', marginLeft: '110px'}}>
        {/* header Left */}
        <div className="header-left-side " style={{width:'90%'}}>
          {/* Logo & Text */}
          <div className="new-sales-report-Logo-Container">
            <div>
              <img width={250} height={72} src={Logo} />
            </div>
            {/* Logo Items */}
            <div className="new-sales-report-Logo_items">
              <div>DL1961 Premium Denim Inc.</div>
              <div>121 Varick Street,4th Floor</div>
              <div>NEW YORK ,NY 10013, USA</div>
              <div>TEL : (646) 514-9736</div>
              <div>FAX : (212) 991-9989</div>
              <div>EMAIL : sales@DL1961.com</div>
            </div>
            <div  style={{fontSize: '18px', margin: 'auto', textDecoration: 'underline'}}>
              Customer Payment Report 
            </div>
            {/* <Button style={{ marginBottom: '10px', width: "100px", height: 30, marginTop: 30 }} onClick={printHandler}>
              Print
            </Button> */}
            {/* Logo Items */}
          </div>
          {/* Items details */}
          <div className="items-detail-container">
            {/* Sold To */}
            <div className="sold-to-Container">
              <div className="sold-to sold-to-second">
                <div className="font_weight w-22">Payment No :</div>
                <div className="sold-to-data">{headerData && headerData.payment_header_no}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">Customer :</div>
                <div className="sold-to-data">{headerData?.customer_name}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">Payment Terms :</div>
                <div className="sold-to-data">{headerData && headerData.term_name}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">Payment :</div>
                <div className="sold-to-data">{headerData && headerData.payment_type_name}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">Debit Account :</div>
                <div className="sold-to-data">{headerData && headerData.debit_acc}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">Gender :</div>
                <div className="sold-to-data">{headerData && headerData.gender_name}</div>
              </div>
             
              
            </div>
            {/* Sold To */}
            {/* Ship To */}
            <div className="ship-to-Container">
              <div className="sold-to">
                <div className="font_weight w-22">Date :</div>
                <div className="sold-to-data">{headerData && headerData.payment_date}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">Posting Period :</div>
                {/* <div className="sold-to-data">{headerData?.shipping_firstname ? `${headerData.shipping_firstname + ' ' + headerData.shipping_lastname}` : headerData?.ship_to_addressee ? headerData?.ship_to_addressee : `Attn: ${headerData?.customer_name}`}</div> */}
                <div className="sold-to-data">{headerData?.period_name}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">Memo :</div>
                <div className="sold-to-data">{headerData && headerData.memo}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">A/R Account :</div>
                <div className="sold-to-data">{headerData && headerData.credit_acc}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">Currency :</div>
                <div className="sold-to-data">{headerData && headerData.currency}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight w-22">Remarks :</div>
                <div className="sold-to-data">{headerData && headerData.instrument_no}</div>
              </div>
              
              
            </div>
          </div>
        </div>
       
      </div>
    </div>
  );
};

export default CustomerPaymentPrintHeader;
